import React from "react";
import Axios from 'axios';

import { Link } from "react-router-dom";

import GetAuthHeader from '../../../components/Util/GetAuthHeader';
import GetToken from '../../../components/Util/GetToken';

import {
  Container,
  Row,
  Form,
  Input,
  Label,
  Button,
  Col,
  Card,
  CardBody,
  CardHeader,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink
} from "reactstrap";

import AdminHeader from "components/AdminHeader.jsx";
import Loader from "components/Loader.jsx";

class Overview extends React.Component {
  constructor(props) {
    super(props);

    this.unmounted = false;

    this.state = {
      'loading': true,
      'overview': [],
      'removeAll': false,
      'checkedRemove': [],
      'showAuthor': false,
      'total': 0,
      'offset': 0,
      'postPerPage': 0
    }
  }

  componentWillMount() {
      document.body.classList.remove('bg-red');
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  componentDidMount() {   
    if(GetToken()) {
      Axios.post(this.props.generic.endpoint + 'wp-json/jwt-auth/v1/token/validate', {}, {
        'headers': GetAuthHeader()
      })
        .then( response => {
          if(this.unmounted) return;  

          this.getOverview.bind(this)();
        })
        .catch( error => {
          this.setState({
            'loading': false
          }, () => {
            this.props.history.push('/auth/login');
          })
        });
    } else {
      setTimeout(() => {
        this.setState({
          'loading': false
        }, () => {
          this.props.history.push('/auth/login');
        })
      }, 1000);
    }
  }

  getOverview() {
    Axios.post(this.props.generic.endpoint + 'wp-json/dpg/v1/get-overview', {
      'offset': this.state.offset
    }, {
      'headers': GetAuthHeader()
    })
      .then( response => {
        if(this.unmounted) return;  

        this.setState({
          'overview': response.data.data.widgets,
          'showAuthor': response.data.data.showAuthor,
          'postPerPage': response.data.data.posts_per_page,
          'total': response.data.data.total,
          'loading': false
        });

      })
      .catch( error => {
        this.setState({
          'loading': false
        })
      });
  }

  toggleEnabled(id, e) {
    const isEnabled = e.target.checked;
    const newValue = (isEnabled ? 'y' : 'n');

    this.setState({
      'loading': true
    });

    Axios.post(this.props.generic.endpoint + 'wp-json/dpg/v1/toggle-enabled-state', {
        'enabled': newValue,
        'id': id
      }, {
        'headers': GetAuthHeader()
      })
        .then( response => {
            if(this.unmounted) return;  

            this.getOverview.bind(this)();
          })
          .catch( error => {
            this.setState({
              'loading': false
            }, () => {
              this.props.history.push('/auth/login');
            })
          });
  }

  renderRow(data) {
    if(data === undefined) {
      return false;
    }

    if(data.length < 1) {
      return (
        <tr>
          <td colSpan="5">Je hebt nog geen widgets aangemaakt.</td>
        </tr>
      );
    }

    return data.map((row, count) => {
      return (
        <tr key={count} className="bg-white">
          <th>
            <div className="custom-control custom-checkbox">
              <input
                className="custom-control-input"
                id={`table-check-${row.id}`}
                type="checkbox"
                checked={this.isChecked.bind(this, row.id)()}
                onChange={this.toggleRemove.bind(this, row.id)}
              />
              <label
                className="custom-control-label"
                htmlFor={`table-check-${row.id}`}
              />
            </div>
          </th>
          <td>
            <span className="text-muted" dangerouslySetInnerHTML={{__html: row.title}}></span>
          </td>

          {(this.state.showAuthor &&
            <td>
              <span className="text-muted" dangerouslySetInnerHTML={{__html: row.author}}></span>
            </td>
          )}

          <td>
            <span className="text-muted">{row.published}</span>
          </td>
          <td>
            <span className="text-muted">
              <label className="custom-toggle">
                <input
                  type="checkbox"
                  onChange={this.toggleEnabled.bind(this, row.id)}
                  checked={row.enabled === 'y'}
                />
                <span
                  className="custom-toggle-slider rounded-circle"
                  data-label-off="Nee"
                  data-label-on="Ja"
                  
                />
              </label>
            </span>
          </td>
          <td>
            <span className="text-muted d-flex justify-content-end">
              <Link to={`/admin/detail/${row.id}`}>
                <Button color="white" size="sm" type="button" className="btn-icon btn-3 button--with-icon button--with-icon-small">
                  <span className="btn-inner--icon">
                    <i className="ni ni-settings text-md text-dark" />
                  </span>
                  <span className="btn-inner--text text-dark">Bewerken</span>
                </Button>
              </Link>
            </span>
          </td>
        </tr>
      );
    });
  }

  isChecked(id) {
    // console.log('isChecked', id, this.state.checkedRemove);

    const isChecked = this.state.checkedRemove.indexOf(id) > -1;

    return isChecked;
  }

  removeAll() {
    this.setState({
      'removeAll': !this.state.removeAll
    }, () => {
      if(this.state.removeAll) {
        let toRemove = [];

        this.state.overview.forEach((item) => {
          toRemove.push(item.id);
        });

        this.setState({
          'checkedRemove': toRemove
        });
      } else {
        this.setState({
          'checkedRemove': []
        });
      }
    });
  }

  toggleRemove(id, e) {
    let toRemove = this.state.checkedRemove;

    if(toRemove.indexOf(id) > -1) {
      toRemove.splice(toRemove.indexOf(id), 1);
    } else {
      toRemove.push(id);
    }

    this.setState({
      'checkedRemove': toRemove,
      'removeAll': (this.state.overview.length === toRemove.length ? true : false)
    });
  }

  removeWidgets() {
    this.setState({
      'loading': true
    });

    Axios.post(this.props.generic.endpoint + 'wp-json/dpg/v1/remove-widgets', {
      'items': this.state.checkedRemove
    }, {
      'headers': GetAuthHeader()
    })
      .then( response => {
          if(this.unmounted) return;  

          this.getOverview.bind(this)();

          this.setState({
            'checkedRemove': []
          });
          console.log(response);
        })
        .catch( error => {
          this.setState({
            'loading': false
          }, () => {
            this.props.history.push('/auth/login');
          })
        });
  }

  renderPagination() {
    const pages = (this.state.total / this.state.postPerPage);
    const hasMultiplePages = pages > 1;


    if(hasMultiplePages) {
      return (
        <nav className="my-1">
          <Pagination>
            <PaginationItem className={(this.state.offset === 0 ? 'disabled' : '')}>
              <PaginationLink
                onClick={this.switchPage.bind(this, '-')}
                tabIndex="-1"
              >
                <i className="fa fa-angle-left" />
                <span className="sr-only">Vorige</span>
              </PaginationLink>
            </PaginationItem>

            {this.renderPageButtons.bind(this)()}

            <PaginationItem className={(this.state.offset >= (pages - 1) ? 'disabled' : '')}>
              <PaginationLink
                onClick={this.switchPage.bind(this, '+')}>
                <i className="fa fa-angle-right" />
                <span className="sr-only">Volgende</span>
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        </nav>
      );
    }
  }

  renderPageButtons() {
    let pages = [];

    for(let i = 0; i < (this.state.total / this.state.postPerPage); i++) {
      pages.push(
        <PaginationItem key={i} className={(this.state.offset === i ? 'active' : '')}>
          <PaginationLink href="#pablo" onClick={this.switchPage.bind(this, i)}>
            {i + 1}
          </PaginationLink>
        </PaginationItem>
      );
    }

    return pages;
  }

  switchPage(page, e) {
    e.preventDefault();

    let offset = this.state.offset;

    if(page === '-') {
      offset = offset - 1;
    } else if(page === '+') {
      offset = offset + 1;
    } else {
      offset = page;
    }

    this.setState({
      'offset': offset,
      'loading': true
    }, () => {
      this.getOverview.bind(this)();
    });
  }

  render() {
    return (
      <>
        <AdminHeader
          history={this.props.history}
          items={[
            {
              'name': 'Dashboard',
              'path': false
            },
            {
              'name': 'Overzicht',
              'path': false
            }
          ]}
        />

        <Container className="mt-2">
          <Row className="justify-content-center">
            <Col md="12">

              <Card className="bg-red text-white border-0 mb-0 p-2 mt-2 mt-md-5">
                  <CardBody className="px-lg-5 py-lg-4">
                    <Row className="d-flex justify-content-between">
                      <Col xs="12" sm="9" md="7">
                        <strong className="text-uppercase text-sm mb-2 d-block">Beheer RSS Widgets</strong>
                        <p className="text-md mb-0">Maak een nieuwe RSS widget door op de "Maak nieuwe widget"-knop te klikken of bewerk één van de bestaande RSS widgets hieronder.</p>
                      </Col>
                      <Col sm="3 "md="5" lg="4" className="d-none d-sm-flex align-items-center justify-content-end">
                        <img src={require('assets/img/illustration/content.svg')} alt="DPG Media logo" className="mt-md--8 mw-100" />
                      </Col>
                    </Row>
                  </CardBody>
              </Card>

            </Col>
          </Row>
        </Container>

         <Container className="mt-5">
          <Row className="justify-content-end">
            <Col xs="auto">
              <Link to={`/admin/detail/new`}>
                <Button color="dark" type="button" className="btn-icon btn-3 button--with-icon">
                  <span className="btn-inner--icon">
                    <i className="ni ni-fat-add text-lg" />
                  </span>
                  <span className="btn-inner--text">Maak nieuwe widget</span>
                </Button>
              </Link>
            </Col>
          </Row>
        </Container>

        <Container className="mt-4">
          <Row className="justify-content-center">
            <Col md="12">

              <Card className="bg-secondary border-0 mb-0">

                <Loader active={this.state.loading}>

                  <CardHeader className="border-0">
                    <h4 className="mb-0">RSS Widgets</h4>
                  </CardHeader>

                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th>
                          <div className="custom-control custom-checkbox">
                            <input
                              className="custom-control-input"
                              id="table-check-all"
                              type="checkbox"
                              checked={this.state.removeAll}
                              onChange={this.removeAll.bind(this)}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="table-check-all"
                            />
                          </div>

                        </th>
                        <th>Naam</th>

                        {(this.state.showAuthor &&
                          <th>Eigenaar</th>
                        )}

                        <th>Aangemaakt op</th>
                        <th>Actief</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderRow(this.state.overview)}
                    </tbody>
                  </Table>

                </Loader>
              </Card>

              <div className="mt-4 mb-1">
                <Row>
                  <Col md="6">
                    <Button color="danger" size="md" outline type="button" disabled={this.state.checkedRemove.length === 0} onClick={this.removeWidgets.bind(this)} style={{'overflow': 'hidden', 'display': 'block'}}>
                      Verwijderen ({this.state.checkedRemove.length})
                    </Button>
                  </Col>
                  <Col md="6" className="justify-content-end d-flex">
                    {this.renderPagination.bind(this)()}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>

      </>
    );
  }
}

export default Overview;
